export function isCurrentSessionRevocation(event, currentSessionId) {
    if (!currentSessionId) return false;

    const targetSessionIds = [
        event?.targetSessionIds,
        event?.payload?.targetSessionIds,
        event?.payload?.sessionIds,
        event?.sessionIds,
    ].find(Array.isArray) || [];

    return targetSessionIds.some((sessionId) => String(sessionId) === String(currentSessionId));
}

export function translateSessionEndReason(translate, reason = "session_expired") {
    const key = `security.session-ended.${reason}`;
    const translated = translate(key);
    return translated === key ? translate("security.session-ended") : translated;
}
